import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: localStorage.getItem('user'),
    token: localStorage.getItem('token'),
    roles: localStorage.getItem('roles'),
    // Users device id - should not change really
    dusi: localStorage.getItem('dusi'),
    isPro: localStorage.getItem('isPro'),
    cookieConsent: localStorage.getItem('cookieConsent'),
  },
  getters: {
    userLoggedIn(state) {
        return (state.user) ? true : false;
    },
    getInitial(state) {
      if (state.user) {
        return state.user.charAt(0).toUpperCase();
      }
      return ''
    },
    getUser(state) {
      if (state.user) {
        return state.user;
      }
      return ''
    },
    // admin > dev > recruiter > user
    getAllRoles(state) {
      if (state.roles) {
        return state.roles
      }
      return ''
    },
    getHighestRole(state) {
      if (state.roles) {
        return state.roles.toString().split(',')[0]
      }
      return ''
    },
    isUser(state) {
      if (state.roles.toString().split(',').length == 1 && state.roles.includes("user")) {
        return true
      }
      return false
    },
    isProUser(state) {
        return (state.isPro) ? true : false;
    },
    isAdmin(state) {
      if (state.roles) {
        return state.roles.includes("admin")
      }
      return false
    },
    isDev(state) {
      if (state.roles) {
        return state.roles.includes("dev")
      }
      return false
    },
    // admins and devs get the same access to PRO-only features (AI review tiers, PRO panel, ...) as PRO users
    hasProAccess(_state, getters) {
      return getters.isProUser || getters.isAdmin || getters.isDev
    },
    canUseProAiReviews(_state, getters) {
      return getters.hasProAccess
    },
    isReviewer(state) {
      if (state.roles) {
        return state.roles.includes("reviewer")
      }
      return false
    },
    getDusi(state) {
      if (!state.dusi) {
        // if it doesn't exist, create a new one
        localStorage.setItem("dusi", self.crypto.randomUUID().substring(0,8));
      }
      return state.dusi
    },
    getCookieConsent(state) {
       return (state.cookieConsent) ? true : false;
    }
  },
  mutations: {
    setUser(state, _user) {
                if(_user) {
                      state.user = _user
            localStorage.setItem("user", _user);
        } else {
          localStorage.removeItem("user");
        }
    },
    setIsPro(state, _isPro) {
      if(_isPro) {
        state.isPro = _isPro
        localStorage.setItem("isPro", _isPro);
      } else {
        localStorage.removeItem("isPro");
      }
    },
    setToken(state, _token) {
        if(_token) {
            state.token = _token
            localStorage.setItem("token", _token);
        } else {
            localStorage.removeItem("token");
        }
    },
    setRoles(state, _roles) {
      if(_roles) {
          state.roles = _roles
          localStorage.setItem("roles", _roles);
      } else {
          localStorage.removeItem("roles");
      }
    },
    refresh(state) {
      state.user = localStorage.getItem('user')
      state.token = localStorage.getItem('token')
      state.roles = localStorage.getItem('roles')
      state.dusi = localStorage.getItem('dusi')
      state.isPro = localStorage.getItem('isPro')
    },
    setCookieConsent(state, _cookieConsent) {
      if(_cookieConsent) {
        state.cookieConsent = _cookieConsent
        localStorage.setItem("cookieConsent", _cookieConsent);
      } else {
        localStorage.removeItem("cookieConsent");
      }
    }
  },
  actions: {
    logout (context) {
      context.commit('setUser', '')
      context.commit('setToken', '')
      context.commit('setRoles', '')
      context.commit('setIsPro', '')
      context.commit('refresh')
    },
  },
  modules: {
  }
})

export default store
